import type { OrganizationMembership } from 'pure-js/types/OrganizationMembership'
import type { ApiResponse } from '../../apiLayer/types'
import type { Organization } from 'pure-js/types/types'

/**
 * Maps each visible org id to its display name. Orgs whose name hasn't loaded yet
 * are omitted (not mapped to their id) so callers can show a placeholder, never the id.
 */
export function buildOrgLabelByOrgId(
  visible: OrganizationMembership[],
  labelQueries: Array<{ data?: ApiResponse<Organization | undefined> } | undefined>
): Record<string, string> {
  const map: Record<string, string> = {}
  visible.forEach((membership, index) => {
    const name = labelQueries[index]?.data?.data?.name
    if (name?.trim()) {
      map[membership.organizationId] = name
    }
  })
  return map
}
